<div class="d-flex justify-content-center" aria-label="breadcrumb">
  <ul class="breadcrumb">
    <li *ngFor="let item of items; let i = index" class="breadcrumb-item">
      <div class="" ngbDropdown #breadcrumbDrop="ngbDropdown">
        <button
          class="btn btn-breadcrumb"
          (click)="$event.stopPropagation(); breadcrumbDrop.toggle()"
        >
          <img class="btn-icon" [src]="item.icon" alt="icon" />
          <div class="btn-name">
            <span class="truncate-text"
                  [ngbTooltip]="item.selectedModel ? item.selectedModel.name :
                              (item.selectedNode ? item.selectedNode.description : item.name)">
              <ng-container *ngIf="!item.selectedModel && !item.selectedNode">
                {{ item.name}}
              </ng-container>
              <ng-container *ngIf="item.selectedModel">
                {{item.selectedModel.name}}
              </ng-container>
              <ng-container *ngIf="item.selectedNode">
                {{ item.selectedNode.description }}
              </ng-container>
            </span>
          </div>
        </button>
        <div ngbDropdownMenu>
          <button
            class="btn btn-breadcrumb view-all"
            ngbDropdownItem
            (click)="viewAllBreadcrumbClick(item, i)"
          >
            View all
          </button>
          <hr />
          <ng-container *ngIf="item.alternativeNodes?.length">
            <button
              *ngFor="let alternative of item.alternativeNodes"
              class="btn btn-breadcrumb"
              ngbDropdownItem
              [ngClass]="
                alternative.description === item.selectedNode?.description
                  ? 'selected-element'
                  : ''
              "
              (click)="selectNode(i, alternative)"
            >
              <img class="btn-icon" [src]="alternative.img" alt="icon" />
              <span class="truncate-text" [ngbTooltip]="alternative.description">{{ alternative.description }}</span>
            </button>
          </ng-container>
          <ng-container *ngIf="item.alternativeModels?.length">
            <button
              *ngFor="let alternative of item.alternativeModels"
              class="btn btn-breadcrumb"
              ngbDropdownItem
              [ngClass]="
                alternative.id === item.selectedModel?.id
                  ? 'selected-element'
                  : ''
              "
              (click)="selectModel(i, alternative)"
            >
              <img class="btn-icon" [src]="alternative.img" alt="icon" />
              <span class="truncate-text" [ngbTooltip]="alternative.name">{{ alternative.name }}</span>
            </button>
          </ng-container>
        </div>
      </div>
    </li>
  </ul>
</div>
